import clsx from 'clsx';

import { FadeIn, FadeInStagger } from '../FadeIn';

import { EyebrowText } from './EyebrowText';

interface ISectionHeaderProps {
  /**
   * The class name to be applied to the wrapper container.
   */
  className?: string;
  /**
   * The class name to be applied to the eyebrow text.
   */
  classNameEyebrow?: string;
  /**
   * The class name to be applied to the title text.
   */
  classNameTitle?: string;
  /**
   * The eyebrow text for the section header.
   */
  eyebrowText: string;
  /**
   * The title text for the section header.
   */
  title: string;
  /**
   * Amount of time in seconds to delay the animation
   */
  fadeInDelay?: number;
  /**
   * Duration over which to animate the header
   */
  fadeInDuration?: number;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a section header with eyebrow and title text.
 */
export function SectionHeader({
  className,
  classNameEyebrow,
  classNameTitle,
  eyebrowText,
  fadeInDelay = 0,
  fadeInDuration = 0.01,
  title,
}: ISectionHeaderProps) {
  return (
    <FadeInStagger
      className={clsx(
        'flex flex-col items-center gap-2 text-center',
        className
      )}
      faster
    >
      <EyebrowText
        className={classNameEyebrow}
        fadeInDelay={fadeInDelay}
        fadeInDuration={fadeInDuration}
        initOpacity={0.5}
        initY={-24}
        text={eyebrowText}
      />
      <FadeIn
        className={clsx(
          `
            sowed block max-w-xl text-4xl font-medium tracking-tight
            text-gray-950 [text-wrap:balance] max-lg:max-w-full
            max-lg:text-3xl max-sm:text-2xl sm:text-5xl
          `,
          classNameTitle
        )}
        initOpacity={0.5}
      >
        {title}
      </FadeIn>
    </FadeInStagger>
  );
}
